import React from 'react';
import { Box, BoxProps } from '../../../../CommonComponents/OPL/Box/Box';
import { Legend } from '../Legend/Legend';
import { Chart } from '../Chart/Chart';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';

interface SimilarityScoreProps extends BoxProps {
  secondaryRespondentName?: string;
  compatibilityScore: number;
}

export const SimilarityScore = ({
  secondaryRespondentName,
  compatibilityScore,
  ...rest
}: SimilarityScoreProps) => {
  return (
    <Box {...rest}>
      <Box position="relative" pt="24" pb={secondaryRespondentName ? '24' : '0'}>
        <Legend direction="pointDown" percentage={compatibilityScore}>
          You &amp; {secondaryRespondentName}
        </Legend>

        <Chart size="large" score={compatibilityScore}>
          <Text
            color={compatibilityScore === undefined ? 'white' : 'neutral.700'}
            fontWeight={600}
            fontSize="small"
          >
            Low Similarity
          </Text>

          <Text
            color={compatibilityScore === undefined ? 'white' : 'neutral.700'}
            fontWeight={600}
            fontSize="small"
          >
            High Similarity
          </Text>
        </Chart>
      </Box>
    </Box>
  );
};
